import gql from 'graphql-tag';

export const ALL_AUDIENCE_PARAMETERS = gql`
  query allAudienceParameters {
    allAudienceParameters {
      type
      name
      cardinality
    }
  }
`;

export const GET_AUDIENCE_PARAMETER_VALUES = gql`
  query audienceParameterValues(
    $type: AudienceParameterType!
    $territory: Territory!
  ) {
    audienceParameterValues(type: $type, territory: $territory) {
      id
      name
      active
      activeGrades
      children {
        id
        name
        active
        activeGrades
        children {
          id
          name
          active
          activeGrades
          children {
            id
            name
            active
            activeGrades
          }
        }
      }
    }
  }
`;
